import * as React from 'react';
import { AboutModal } from 'app/shell/components/about-modal';
import { ChangePasswordModal } from 'app/area/user-profile/settings/change-password/change-password-modal';
import { FixedDocument } from 'app/components/fixed-document';
import { RefreshCacheModal } from 'app/shell/components/refresh-cache/refresh-cache-modal';
import { ExportToZipModal } from 'app/area/my-downloads/exports/export-to-zip-modal/export-to-zip-modal';
import { RegenerateAggregatedEnvModal } from 'app/shell/components/regenerate-aggregated/env/regenerate-aggregated-env';
import { RegenerateAggregatedRiskModal } from 'app/shell/components/regenerate-aggregated/risk/regenerate-aggregated-risk';
import { MODAL } from 'app/shell/modal-host-types';

const ModalRegistry = {
  [MODAL.about]: AboutModal,
  [MODAL.changePassword]: ChangePasswordModal,
  [MODAL.refreshCache]: RefreshCacheModal,
  [MODAL.exportToZip]: ExportToZipModal,
  [MODAL.regenerateAggregatedEnv]: RegenerateAggregatedEnvModal,
  [MODAL.regenerateAggregatedRisk]: RegenerateAggregatedRiskModal,
  [MODAL.none]: ''
};

export const modalFor = (modal: string) => {
  return ModalRegistry[modal];
};

export interface ModalHostProps {
  selectedModal: string;
  name: string;
  version?: string;
  onClose: () => void;
}

export const ModalHost = (props: ModalHostProps) => {
  const {
    selectedModal,
    ...otherProps
  } = props;

  if (!selectedModal) {
    return null;
  }

  const Instance = modalFor(selectedModal) as any;

  return <FixedDocument>
      <Instance {...otherProps}/>
    </FixedDocument>;
};
